import { createComponent } from '@/helpers/alpine';
import { throttle } from 'lodash-es';

const StickyAddToCart = createComponent(() => ({
    threshold: 700,
    isAffixed: false,

    calcAffix() {
        this.isAffixed = window.scrollY > this.threshold;
    },

    init() {
        window.addEventListener('resize', throttle(this.calcAffix.bind(this)));
        window.addEventListener('scroll', throttle(this.calcAffix.bind(this)));
    },

    addPixelImg() {
        if (!document.querySelector('.js-pixel-img')) {
            const img = document.createElement('img');
            img.height = 1;
            img.width = 1;
            img.classList.add('js-pixel-img');
            img.style.cssText = 'border-style:none; display:none;';
            img.alt = '';
            img.src =
                'https://insight.adsrvr.org/track/pxl/?adv=tl2d53c&ct=0:5nclpc0&fmt=3';
            document.body.appendChild(img);
        }
    },
}));

export { StickyAddToCart };
